var totalPage;
var pageProduct = 1;
var shop_money_format = money_format;
var shop_money_with_currency_format = money_with_currency_format;
Shopify.formatMoney = function(cents, format) {
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    if (typeof number == 'string'){
      number = parseInt(number).toFixed(precision);
    } else {
      number = (number/100).toFixed(precision);
    }

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
//get data product and render to view 
function getProduct(shop, page, sortBy, state) {
    let url = 'https://brand.spify.io/r3st/api/v1/shopify-app-product/get-product-with-brand-only?shop='
    url += shop;
    url += '&brand_key=';
    url += brand_key;
    url += '&limit=';
    url += 20;
    url += '&page=';
    url += page;
    if(sortBy){
        url += '&';
        url += sortBy.title;
        url += '=';
        url += sortBy.value;  
    }
    fetch(url , {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then((res) => { return res.json(); })
    .then((data) => {
        if(data.data == null || data.data.totalDocs == 0) {
            return true;
        } else {
            let select =`<select class='aht-btn-right-product' id='sort-by' onchange=onSortBy()>
                    <option ${state == 0? 'selected': ''} value='0'>Default</option>
                    <option ${state == 1? 'selected': ''} value='1'>A-Z</option>
                    <option ${state == 2? 'selected': ''} value='2'>Z-A</option>
                    <option ${state == 3? 'selected': ''} value='3'>Price low to high</option>
                    <option ${state == 4? 'selected': ''} value='4'>Price high to low</option>
                </select>`;
            document.getElementById('aht-sort-by').innerHTML = select;
        
            if(data.data.totalPages != 1 && data.data.totalPages ) {
                let htmlpage = '';
                totalPage = data.data.totalPages;
                parsePage(data.data.totalPages).map((item , index) => {
                    if(item === page ){htmlpage+='<li class="active"><span>'+item+'</span></li>'}
                    else htmlpage += '<li onClick="handleChangePage('+ item+')"><a title="">'+item+'</a></li>'}
                )
                document.getElementById("pagination-custom").innerHTML = htmlpage
            }
            if(data.data.docs.length!=0){
                const html = data.data.docs.map((item, index) => {
                    let d = item.variants[0].price;
                    return (
                       `<div class = "col">
                            <div class="item-container item-product hover-border effect-1">
                                <div class="image-wrapper image-spacing" >
                                    <a class="image-item" href = "/products/${item.handle}">
                                        <img class="image-item" src=${item.image? item.image.src : ""}  />
                                    </a> 
                                </div>
                                <div class="item-info">
                                    <a class="text-item" href = "/products/${item.handle}">${item.title}</a>
                                    <div class="aht-money">
                                        <span class= "item-price money">${Shopify.formatMoney(item.variants[0].price, shop_money_format)} </span>                                         
                                           ${ parseInt(item.variants[0].price) < parseInt(item.variants[0].compare_at_price) ? '<strike class="item-old-price"><span class="money">' + Shopify.formatMoney(item.variants[0].compare_at_price, shop_money_format)+'</span></strike>': ''} 
                                    </div>
                                    <div class="aht-btn-add-container">
                                        ${ (item.variants[0].inventory_quantity || item.variants[0].inventory_policy == "continue") ?  '<button class="aht-btn aht-btn-add-cart"  onClick ="addToCart('+ item.variants[0].id +')">Add to cart</button>' : '<button class="aht-btn aht-btn-sold-out"  disabled="true">Sold out</button>'        }
                                    </div>
                                </div>
                            </div>
                        </div>`
                    );
                }).join("");
                document.getElementById("list-product").innerHTML= html;
                
                  if(Currency) {
                    Currency.format = 'money_format';
                    var shopCurrency = Shopify.currency.active;
                    Currency.moneyFormats[shopCurrency].money_with_currency_format = shop_money_with_currency_format;
                    Currency.moneyFormats[shopCurrency].money_format = shop_money_format;
                    var cookieCurrency = Currency.cookie.read();
                    if (cookieCurrency == null) {
                        if (shopCurrency !== defaultCurrency) {
                          Currency.convertAll(shopCurrency, defaultCurrency);
                        }
                        else {
                          Currency.currentCurrency = defaultCurrency;
                        }
                      }
                    else if (jQuery('[name=currencies]').size() && jQuery('[name=currencies] option[value=' + cookieCurrency + ']').size() === 0) {
                      Currency.currentCurrency = shopCurrency;
                      Currency.cookie.write(shopCurrency);
                    }
                    else if (cookieCurrency === shopCurrency) {
                      Currency.currentCurrency = shopCurrency;
                    }
                    else {
                      Currency.convertAll(shopCurrency, cookieCurrency);
                    }
                  }    
                
                let htmlText = '';
                if(data.data.docs.length == 1){
                     htmlText = '<div class = "style-text-header">We found 1 product available for you</div>';
                } else {
                     htmlText = '<div class = "style-text-header">We found '+data.data.totalDocs+' products available for you</div>';
                }
                document.getElementById("text-header-product").innerHTML= htmlText;
            } else {
                const htmlText = '<div class = "style-text-header">We found 0 product available for you</div>';
                document.getElementById("text-header-product").innerHTML= htmlText;
            }
        }
    }).catch(error => {
        console.log(error);
    })
};

function parsePage (total) {
    let arr = [];
    for (let i = 0; i < total; i++) {
        arr.push(i + 1)
    };
    return arr
}
function getBranDetail(shop) {
    let url = 'https://brand.spify.io/r3st/api/v1/shopify-brand-brand-details/get-brand-by-brand-key?';
    url += 'brand_key=';
    url += brand_key;
    url += '&shop=';
    url += shop;
    fetch(url , {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    })
    .then((res) => { return res.json(); })
    .then((data) => {
        if(data.data == null) {
            return true;
        } else {
            if (data.data != null) {
                const htmlDescription = '<h2 class="brand-title">'+data.data.brand_name+'</h2>';
                document.getElementById("page-title").innerHTML = htmlDescription;
                if (data.data.brand_image) {
                    var image = document.createElement('img');
                    image.setAttribute('src', data.data.brand_image);
                    image.setAttribute('alt', data.data.brand_name);
                    document.getElementById("brand-image").appendChild(image);
                }
                if (data.data.description){
                      const htmlDescription = '<span class = "brand-description">'+data.data.description+'</span>';
                      document.getElementById("brand-description").innerHTML = htmlDescription;
                }
            }
        }
    })
}
getProduct('ar-electromax.myshopify.com', 1);
getBranDetail('ar-electromax.myshopify.com');
function onSortBy() {
    var e = document.getElementById("sort-by")
    var select_value = e.options[e.selectedIndex].value;
    switch (select_value) {
        case '1':
            return getProduct('ar-electromax.myshopify.com',  1, {title: 'title', value: 1}, 1);
        case '2':
            return getProduct('ar-electromax.myshopify.com',  1, {title: 'title', value: -1}, 2);
        case '3':
            return getProduct('ar-electromax.myshopify.com', 1, {title: 'price', value: 1}, 3);
        case '4':
            return getProduct('ar-electromax.myshopify.com',  1, {title: 'price', value: -1}, 4);
        default:
              return getProduct('ar-electromax.myshopify.com', page);  
    };
}

function handleChangePage(page) {
    if(pageProduct !== page){
        pageProduct = page;
        var e = document.getElementById("sort-by");
        var sortValue = e.options[e.selectedIndex].value;
        switch (sortValue) {
          case '1':
              return getProduct('ar-electromax.myshopify.com',  page, {title: 'title', value: 1}, 1);
          case '2':
              return getProduct('ar-electromax.myshopify.com',  page, {title: 'title', value: -1}, 2);
          case '3':
              return getProduct('ar-electromax.myshopify.com', page, {title: 'price', value: 1}, 3);
          case '4':
              return getProduct('ar-electromax.myshopify.com',  page, {title: 'price', value: -1}, 4);
          default:
              return getProduct('ar-electromax.myshopify.com', page);
          };
    }
}

function addToCart (id){
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({items: [{quatity: 1, id : id}]})
    }).then((res) => res.json())
    .then((resp) => {window.location.href ="/cart";})
    .catch((error) => console.log({error}))     
}

    
    